<template>
  <div class="todo__filters-container bg-white">

    <!-- All Tasks -->
    <div class="px-6 py-4 mt-2">
      <span class="flex items-center cursor-pointer transition-all duration-200 hover:text-primary hover:translate-x-1" 
            :class="{'text-primary font-bold': todoFilter == 'all', 'text-gray-600': todoFilter != 'all'}" 
            v-on:click="setFilter('all')">
        <feather-icon icon="LayersIcon" :svgClasses="[{'stroke-current': todoFilter == 'all'}, 'h-6 w-6']"></feather-icon>
        <span class="text-lg ml-3">{{$t("todo.opt0")}}</span>
      </span>
    </div>

    <vs-divider class="my-0"></vs-divider>

    <!-- Filters (Doing, Done, Trashed) -->
    <div class="px-6 py-6">
      <h5 class="mb-4 font-semibold text-gray-800 tracking-wide text-sm uppercase">{{$t("todo.lbl0")}}</h5>
      <template v-for="filter in todoFilters">
        <span class="flex items-center mt-4 cursor-pointer transition-all duration-200 hover:opacity-75 hover:translate-x-1" 
              :class="{'font-bold': todoFilter == filter.filter, 'text-gray-600': todoFilter != filter.filter}" 
              :key="filter.filter" 
              v-on:click="setFilter(filter.filter)">
          
          <feather-icon :icon="filter.icon" :svgClasses="[filter.color, 'h-5 w-5 stroke-current']"></feather-icon>
          <span class="text-lg ml-3" :class="todoFilter == filter.filter ? filter.color : ''">{{ filter.filterName }}</span>
        </span>
      </template>
    </div>

    <vs-divider class="my-0"></vs-divider>

    <!-- Labels (Attribute, Skill) -->
    <div class="px-6 py-6">
      <h5 class="mb-4 font-semibold text-gray-800 tracking-wide text-sm uppercase">{{$t("todo.lbl1")}}</h5>
      <div class="list-group list-group-labels">
        
        <a class="flex items-center mt-4 cursor-default transition-all duration-200 hover:translate-x-1">
          <div class="ml-1 h-3 w-3 rounded-full mr-3 border border-solid shadow-sm" style="border-color: #ddd6fe; background-color: #6d28d9;" />
          <span class="text-base font-semibold" style="color: #6d28d9;">{{$t("todo.lbl1_opt0")}}</span>
        </a>
        
        <a class="flex items-center mt-4 cursor-default transition-all duration-200 hover:translate-x-1">
          <div class="ml-1 h-3 w-3 rounded-full mr-3 border border-solid shadow-sm" style="border-color: #a7f3d0; background-color: #047857;" />
          <span class="text-base font-semibold" style="color: #047857;">{{$t("todo.lbl1_opt1")}}</span>
        </a>
        
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../i18n/i18n';

export default {
  data () {
    return {
      todoFilters: [
        { filterName: i18n.t('todo.lbl0_opt0'), filter: 'wip', icon: 'ArrowRightIcon', color: 'text-primary' },
        { filterName: i18n.t('todo.lbl0_opt1'), filter: 'done', icon: 'CheckIcon', color: 'text-success' },
        { filterName: i18n.t('todo.lbl0_opt2'), filter: 'todo', icon: 'TrashIcon', color: 'text-danger' }
      ],
      todoFilter : 'all'
    }
  },
  methods: {
    setFilter (value) {
      this.todoFilter = value;
      this.$emit('filter', value);
      
      // NEW: Emits event to parent to close the sidebar on smaller screens
      this.$emit('closeSidebar'); 
    }
  }
}
</script>